// extracted by mini-css-extract-plugin
export default {"overflowPopover":"NlVLz5o6srrPngrE7rom__overflowPopover___","contactDetail":"xvUcPmCNJjX90gdoBjpx__contactDetail___","blurred":"r_J4Q1aemEGy5RpIM3a5__blurred___"};